import styled from "styled-components";

const SubInfo = styled.p`
  font-size: 1.6rem;
  color: #3f3f3f;
  margin: 0;
`;

export default SubInfo;
